/** The tool names the runtime writes, with the word a reader sees. */
export const GRAPH_TOOL_LABELS = {
    GET_PROPERTY_LISTINGS: 'Listings',
    SWITCH_LANGUAGE: 'Language',
};
export function graphToolLabel(tool) {
    return typeof tool === 'string' ? (GRAPH_TOOL_LABELS[tool] ?? tool) : 'Tool';
}
//# sourceMappingURL=tool-labels.js.map